module.exports = __webpack_public_path__ + "assets/img/aiteLogo.c8736845.png";